<script>
import { userListMethod } from '@state/helpers'
export default {
  props: {
    data: {
      type: Object,
      required: true,
      default: () => {},
    },
  },
  data() {
    return {
      show: true,
    }
  },
  methods: {
    ...userListMethod,
    deleteData() {
      const userData = {
        id: this.data._id,
      }
      this.deleteUser({ userData }).then((data) => {
        this.isLoading = false
        this.$bvToast.toast('Teacher Deleted Successfully', {
          title: `Success`,
          toaster: 'b-toaster-top-right',
          solid: true,
          variant: 'success',
          appendToast: false,
        })
        setTimeout(() => {
          window.location.reload()
        }, 1500)
      })
    },
  },
}
</script>
<template>
  <div class="alert">
    <b-modal
      id="teacher-delete-modal"
      v-model="show"
      title="delete"
      ok-title="Delete"
      :hide-footer="false"
      @ok="deleteData"
    >
      <template v-slot:modal-title>
        <h4>Delete</h4>
      </template>
      <p
        >Are you sure you want to delete teacher {{ data.first_name }}
        {{ data.last_name }} ?</p
      >
    </b-modal>
  </div>
</template>
<style>
.btn-secondary {
  color: #545b62 !important;
  background-color: white !important;
  border-color: #ced4da !important;
}
</style>
